// document.addEventListener('DOMContentLoaded', function() {
//   const variantSelect = document.querySelector('[name="id"]');
//   const stockQuantityElement = document.getElementById('current-stock-quantity');
  

//   document.addEventListe
  
//   console.log(stockQuantityElement,5);

  
// });

// var infoElement = document.querySelector(".product__info-container");

// infoElement.addEventListener('change', function(event) {
//   console.log(event.target.value);
// });

// window.allVariants = {{ product.variants | json }};

$(document).ready(function() {
    $('a[href^="#"]').on('click', function(e) {
        e.preventDefault();
        var target = this.hash;
        var $target = $(target);
        if ($target.length) {
            $('html, body').stop().animate({
                'scrollTop': $target.offset().top
            }, 900, 'swing', function() {
                // window.location.hash = target;
            });
        } else {
            window.location.href = '/' + target;
        }
    });
});